const normalSvgs = import.meta.glob('/src/assets/svg/normal/*.svg', { 
  eager: true,
  query: '?url',
  import: 'default'
});

const hoverSvgs = import.meta.glob('/src/assets/svg/hover/*.svg', { 
  eager: true,
  query: '?url',
  import: 'default'
});

const createSvgMap = (svgObject) => {
  const map = {};
  Object.entries(svgObject).forEach(([path, url]) => {
    const filename = path.split('/').pop().replace('.svg', '');
    map[filename] = url;
  });
  return map;
};

const normalMap = createSvgMap(normalSvgs, 'normal');
const hoverMap = createSvgMap(hoverSvgs, 'hover');

const getSelectedHairLength = () => {
  try {
    const selections = JSON.parse(localStorage.getItem('selections') || '{}');
    
    const hairSteps = ['f-b-1', 'f-c-1', 'f-g-1'];
    
    for (const step of hairSteps) {
      const stepSelection = selections[step];
      
      if (stepSelection) {
        if (stepSelection.Longeur && stepSelection.Longeur.choice) {
          const lengthChoice = stepSelection.Longeur.choice.label;
          return mapLengthToSuffix(lengthChoice);
        }
        
        if (stepSelection.choice && stepSelection.choice.group === 'Longeur') {
          const lengthChoice = stepSelection.choice.label;
          return mapLengthToSuffix(lengthChoice);
        }
        
        for (const [, groupSelection] of Object.entries(stepSelection)) {
          if (groupSelection && groupSelection.choice && groupSelection.choice.group === 'Longeur') {
            const lengthChoice = groupSelection.choice.label;
            return mapLengthToSuffix(lengthChoice);
          }
        }
      }
    }
    
    return '';
  } catch (error) {
    console.error('Erreur lors de la récupération de la longueur de cheveux:', error);
    return '';
  }
};

const mapLengthToSuffix = (lengthLabel) => {
  const mapping = {
    'Courts': '-courts',
    'Mi-longs': '-milongs',
    'Longs': '-longs', 
    'Extra-longs': '-extralongs'
  };
  
  return mapping[lengthLabel] || '';
};

export const getSvgPaths = (imgName) => {  
  let targetImageName = imgName;
  
  if (imgName && imgName.startsWith('femme-')) {
    const hairLengthSuffix = getSelectedHairLength();
    
    const hasLengthSuffix = imgName.includes('-courts') || 
                           imgName.includes('-milongs') || 
                           imgName.includes('-longs') || 
                           imgName.includes('-extralongs');
    
    
    if (hairLengthSuffix && !hasLengthSuffix) {
      const imageWithSuffix = imgName + hairLengthSuffix;
      
      if (normalMap[imageWithSuffix]) {
        targetImageName = imageWithSuffix;
      }
    }
  }
  
  const normal = normalMap[targetImageName];
  const hover = hoverMap[targetImageName] || hoverMap[`${targetImageName}-hover`];
  
  return {
    normal,
    hover,
    hasNormal: !!normal,
    hasHover: !!hover,
    usedImageName: targetImageName
  };
};

export const refreshIconsForHairLength = () => {
  const event = new CustomEvent('hair-length-icons-refresh');
  document.dispatchEvent(event);
};

export const getIconVariants = (baseImgName) => {
  const variants = {};
  const suffixes = ['', '-milongs', '-longs', '-extralongs'];
  
  suffixes.forEach(suffix => {
    const variantName = baseImgName + suffix;
    if (normalMap[variantName]) {
      const lengthLabel = suffix === '' ? 'Courts' : 
                         suffix === '-milongs' ? 'Mi-longs' :
                         suffix === '-longs' ? 'Longs' : 'Extra-longs';
      variants[lengthLabel] = {
        name: variantName,
        normal: normalMap[variantName],
        hover: hoverMap[variantName] || hoverMap[`${variantName}-hover`]
      };
    }
  });
  
  return variants;
};

export { normalMap, hoverMap };

export const getAvailableSvgNames = () => {
  return Object.keys(normalMap);
};
